/*
 * @Copyright: @ Silk Software Corp. All Rights Reserved Based on MIT-LICENSE
 */
import { gql } from '@apollo/client'

export const SUPER_ADMIN_BEGIN_MASQUERADE = gql`
  mutation getSuperAdminBeginMasquerade($companyId: Int!, $userId: Int!) {
    superAdminBeginMasquerade(companyId: $companyId, userId: $userId) {
      userInfo {
        email
        firstName
        lastName
        phoneNumber
      }
    }
  }
`
